export default __webpack_public_path__ + "images/1C.27b6cba.png";